export const KEY_MAP = '&key=AIzaSyB0x6z341yKsq0RRvrxS5EJZXpokQ47rrQ';
